import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Season } from '../../../clients'

type SeasonStoreType = Omit<Season,
    'beginDate' | 'endDate' | 'regularSeasonBeginDate' | 'regularSeasonEndDate' | 'createdAt' | 'updatedAt'
> & {
    beginDate: string,
    endDate: string,
    regularSeasonBeginDate: string,
    regularSeasonEndDate: string,
    createdAt: string,
    updatedAt: string
}

interface SeasonsState {
    seasons: SeasonStoreType[]
    currentSeason: SeasonStoreType | null
    mostRecentSeason: SeasonStoreType | null
}

const initialState: SeasonsState = {
    seasons: [],
    currentSeason: null,
    mostRecentSeason: null
}

const seasonsSlice = createSlice({
    name: 'seasons',
    initialState,
    reducers: {
        setSeasons(state, payload: PayloadAction<SeasonStoreType[]>) {
            state.seasons = payload.payload
            state.currentSeason = payload.payload.find(x => {
                const now = new Date()
                return new Date(x.beginDate) <= now && new Date(x.endDate) >= now
            })
            state.mostRecentSeason = payload.payload.length > 0 ? payload.payload.reduce((prev, current) => {
                return (new Date(prev.endDate) > new Date(current.endDate)) ? prev : current
            }) : null
        },
        addSeason(state, payload: PayloadAction<SeasonStoreType>) {
            state.seasons.push(payload.payload)
            state.currentSeason = state.seasons.find(x => {
                const now = new Date()
                return new Date(x.beginDate) <= now && new Date(x.endDate) >= now
            })
            state.mostRecentSeason = state.seasons.reduce((prev, current) => {
                return (new Date(prev.endDate) > new Date(current.endDate)) ? prev : current
            })
        },
        updateSeason(state, payload: PayloadAction<SeasonStoreType>) {
            const index = state.seasons.findIndex(x => x.id === payload.payload.id)
            state.seasons[index] = payload.payload
            state.currentSeason = state.seasons.find(x => {
                const now = new Date()
                return new Date(x.beginDate) <= now && new Date(x.endDate) >= now
            })
            state.mostRecentSeason = state.seasons.reduce((prev, current) => {
                return (new Date(prev.endDate) > new Date(current.endDate)) ? prev : current
            })
        }
    }
})

export const { setSeasons, addSeason, updateSeason } = seasonsSlice.actions
export default seasonsSlice.reducer